import React, { Fragment } from "react";
import { Link } from "gatsby";
import { Icon } from "semantic-ui-react";
import { OutboundLink } from "gatsby-plugin-google-gtag";
import { SiteMapContext } from "../layout";

export const UmLink = ({ children, ...others }) => {
  return (
    <SiteMapContext.Consumer>
      {sm => {
        if (
          !sm ||
          !sm.locale ||
          !sm.dl ||
          !sm.dl.exe ||
          !sm.dl.exe.um ||
          !sm.dl.exe.um[sm.locale]
        ) {
          // Fallback
          return <OutboundLink {...others}>{children}</OutboundLink>;
        }

        const localizedUrl = sm.dl.exe.um[sm.locale];
        return (
          <OutboundLink href={localizedUrl} {...others}>{children}</OutboundLink>
        );
      }}
    </SiteMapContext.Consumer>
  );
};
